import {useAddFundForm} from '../../model';
import {useNavigate} from 'react-router';
import {FormInput, TextEditor, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text, Button} from '@gravity-ui/uikit';
import styles from './AddFundForm.module.scss';
import {useEffect} from 'react';

export const AddFundForm = () => {
  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Фонд',
    title: 'Ошибка при добавлении фонда',
  });

  const {values, handleChange, setFieldValue, handleSubmit, handleBlur, touched, errors, isLoading, submitError} =
    useAddFundForm();

  const navigate = useNavigate();
  const handleCancel = () => {
    navigate('/fundraisings/funds');
  };

  const handleEditorBlur = (content: string) => {
    const processedContent = content === '<p><br></p>' ? '' : content;
    setFieldValue('detailedDescription', processedContent);
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    handleSubmit(e);
  };

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <form onSubmit={handleFormSubmit} className={styles.form}>
        <FormInput
          label="Название фонда"
          placeholder="Введите название фонда"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          size="s"
          isRequired={true}
          error={touched.name && errors.name}
        />
        <FormInput
          label="Телефон"
          placeholder="Введите номер телефона"
          name="phoneNumber"
          value={values.phoneNumber || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          size="s"
          error={touched.phoneNumber && errors.phoneNumber}
        />
        <FormInput
          label="Email"
          placeholder="Введите email"
          name="email"
          value={values.email || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          size="s"
          error={touched.email && errors.email}
        />
        <FormInput
          label="Сайт"
          placeholder="Введите адрес сайта"
          name="website"
          value={values.website || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          size="s"
          error={touched.website && errors.website}
        />

        <FormInput
          label="Краткое описание"
          placeholder="Введите краткое описание фонда"
          name="shortDescription"
          value={values.shortDescription}
          onChange={handleChange}
          onBlur={handleBlur}
          size="m"
          isTextarea
          rows={5}
          isRequired={true}
          error={touched.shortDescription && errors.shortDescription}
        />
        <div className={styles.formRow}>
          <Text variant="subheader-1" whiteSpace="nowrap">
            Подробное описание<span className={styles.required}>*</span>
          </Text>
          <div className={styles.editorContainer}>
            <TextEditor
              value={values.detailedDescription}
              onBlur={handleEditorBlur}
              name="detailedDescription"
              isError={!!errors.detailedDescription}
            />
            {errors.detailedDescription && (
              <Text variant="body-1" color="danger">
                {errors.detailedDescription}
              </Text>
            )}
          </div>
        </div>

        <div className={styles.buttonsContainer}>
          <Button view="normal" size="l" onClick={handleCancel}>
            Отмена
          </Button>
          <Button view="action" size="l" type="submit" loading={isLoading}>
            Создать
          </Button>
        </div>
      </form>

      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
